import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Layout } from "../components";
import Cards from "../blocks/cards";
import { Icon } from "reflexjs";
import Block from "../components/cta.js";
import { Link } from "gatsby";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout mdxType="Layout">
      <Block heading="Maps" text="Explore eviction trends and outcomes at the address or parcel level. Assess how often certain owners file evictions. View eviction filing and judgement rates at the neighborhood level." mdxType="Block" /> 
      <Cards py="2|2|2|2" subheading="" heading="" text="" cards={[{
        heading: "City of Milwaukee Eviction Filings",
        text: "",
        image: {
          src: "/images/parcel-map.png",
          alt: ""
        },
        link: <a display="inline-flex" alignItems="center" variant="text.link">
        <Link to="/sda/third-post/" mdxType="Link">Visualizations</Link>  <Icon name="arrow-right" size="4" ml="2" mdxType="Icon" />
        </a>
      }, {
        heading: "City of Milwaukee Eviction Judgements",
        text: "",
        image: {
          src: "/images/census-tracts.png",
          alt: ""
        },
        link: <a display="inline-flex" alignItems="center" variant="text.link">
        <Link to="/sda/fourth-post/" mdxType="Link">Visualizations</Link>  <Icon name="arrow-right" size="4" ml="2" mdxType="Icon" />
        </a>
      }]} mdxType="Cards" />
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      